import { Component, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { PointToContactService } from '../../../services/raintree/Transmission/point-to-contact.service';
import { AppConfigService } from '../../../services/config/app-config.service';

import { CommonModule } from '@angular/common';
import { pocListResponse, pocVO } from '../../../services/raintree/interfaces/Point_of_contact.interface';

@Component({
  selector: 'app-point-of-contact',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
  templateUrl: './point-of-contact.component.html',
  styleUrls: [
    './point-of-contact.component.scss',
    '../../../../styles/_dropdown.scss',
  ],
})
export class PointOfContactComponent implements OnInit {
  stateName: any = ''
  districtName = new FormControl('');
  stateList: any[] = [];
  districtList: any[] = [];
  // selectedDistrict: string = '';
  selectedState = new FormControl('');
  pocDetails: any = [];
  pocList: any[] = [];
  shouldFetchStates = false;
  state: string = '';
  districtUsers: any = null;
  stateUsers: any = null;
  superUser: any = null;
  supportUser: any = null;
  mainData: pocVO[] = [];

  constructor(
    private _appConfig: AppConfigService,
    private poc: PointToContactService
  ) {
    this.selectedState.valueChanges.subscribe((value) => {
      this.onStateChange(value);
    });
    this.districtName.valueChanges.subscribe((value) => {
      this.onDistrictSelect(value);
    });
  }

  ngOnInit() {
    this.getPOCDetailsByState();
    this.fetchPOCDetails(this.districtName?.value, this.selectedState.value);
  }

  // Fetch states and their districts
  getPOCDetailsByState() {
    let allPermissions: any = this._appConfig.fetchPermissionv3ByViewName();
    console.log(allPermissions)
    const countryPerm = allPermissions['INDIA'];
    if (countryPerm.allStatesPerm.length > 0) {
      // fetch all States (not required for poc)
    }
    else {
      Object.entries(countryPerm.statePerms).forEach(([state, stateData]: [any, any]) => {
        this.stateList.push(state);
        this.districtList[state] = [];
        console.log(stateData.allDistrictsPerm.length)
        if (stateData.allDistrictsPerm.length > 0) {
          // fetch all Districts (not required for poc)
          this.districtName.setValue('ALL DISTRICT');
        }
        else {
          Object.entries(stateData.districtPerms).forEach(([district]) => {
            this.districtList[state].push(district);
          })
        }
      })
      this.selectedState.setValue(this.stateList[0]);
      this.stateName = this.stateList[0]
      this.districtName.setValue(this.districtList[this.stateName][0]);
    }
  }

  fetchPOCDetails(district: any, state: any) {
    this.poc.getPOCDetails().subscribe({
      next: (response: any) => {

        const responseData: pocListResponse = response
        // Assuming 'response.data' contains the POC records
        this.mainData = responseData.data

        // Filter the data for district-level users and state-level users
        this.districtUsers = this.mainData.filter(
          (poc: any) =>
            poc.user_district === district &&
            poc.user_role === 'DISTRICT LEVEL USER'
        );

        this.stateUsers = this.mainData.filter(
          (poc: any) =>
            !poc.user_district &&
            poc.user_role === 'STATE LEVEL USER' &&
            poc.user_state === state
        );

        this.superUser = this.mainData.filter(
          (poc: any) => !poc.user_district && poc.user_role === 'SPECIAL USER'
        );

        this.supportUser = this.mainData.find(
          (poc: any) => poc.user_role === 'SUPPORT USER'
        );


      },
      error: (error) => {
        // console.error('Error fetching POC details:', error);
      },
    });
  }

  // Handle state change
  onStateChange(value: any) {
    // this.selectedState = value; // Update the selected state
    this.stateUsers = this.mainData.filter(
      (poc: any) =>
        !poc.user_district &&
        poc.user_role === 'STATE LEVEL USER' &&
        poc.user_state === value
    );
    this.stateName = value
    this.districtName.setValue(this.districtList[value][0]); // Clear district selection when state changes
  }

  // Handle district selection
  onDistrictSelect(district: any) {
    this.districtUsers = this.mainData.filter(
      (poc: any) =>
        poc.user_district === district &&
        poc.user_role === 'DISTRICT LEVEL USER'
    );

    this.fetchPOCDetails(this.districtName?.value, this.selectedState.value);
  }
}
